import { render, staticRenderFns } from "./personalBackground.vue?vue&type=template&id=e90d7002&scoped=true"
import script from "./personalBackground.vue?vue&type=script&lang=js"
export * from "./personalBackground.vue?vue&type=script&lang=js"
import style0 from "./personalBackground.vue?vue&type=style&index=0&id=e90d7002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90d7002",
  null
  
)

export default component.exports